module.exports = __webpack_public_path__ + "static/img/banner.99b15cc4.png";